import { render, staticRenderFns } from "./JournalistsAc.vue?vue&type=template&id=eb5bea68&"
import script from "./JournalistsAc.vue?vue&type=script&lang=js&"
export * from "./JournalistsAc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb5bea68')) {
      api.createRecord('eb5bea68', component.options)
    } else {
      api.reload('eb5bea68', component.options)
    }
    module.hot.accept("./JournalistsAc.vue?vue&type=template&id=eb5bea68&", function () {
      api.rerender('eb5bea68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/journalists-ac/JournalistsAc.vue"
export default component.exports